import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import LinearProgress from '../../../Utils/LinearProgress';
import DeleteIcon from '@material-ui/icons/Delete';
import RUCQModal from './RUCQModal';
import UsedRentalsCQLotsAPI from '../../../../API/UsedRentalsCQLotsAPI';
import ConfirmationDialog from '../../../Utils/ConfirmationDialog';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { handleServerError } from '../../../../Utils/Helper';
import { UR_CREATION_GROUP, NEGOTIATION_PHASE } from '../../../../Utils/Constants';


const headerData = [
  { id: 'color', label: 'COR' },
  { id: 'qtty', label: 'QUANTIDADE' }
];

const styles = theme => ({
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorderHead: {
    border: '2px solid #ffffff'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  tableWrapper: {
    overflowX: 'auto',
    padding: 0
  },
  tblRow: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
    },
    height: '30px'
  },
  iconsWidth: {
    width: '86px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  alignIcons: {
    display: 'flex',
    marginLeft: '13px'
  }
});


class RUCQTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      newEditButton: false,
      openDialog: false,
      loading: false,
      success: false,
      deleteL3Id: '',
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      data: [],
      openError: false,
      alertMessage: ''
    };
  }

  componentDidMount() {
    this.reloadTable();
  };

  reloadTable() {
    const tableDataAPI = new UsedRentalsCQLotsAPI();
    if (this.props.L1ID > 0) {
      this.setState({ loading: true });
      tableDataAPI.getNegotiationCQLotByL2Id(this.props.L2ID).then((response) => {
        this.setState({
          data: response.data.List,
          loading: false
        });
      }).catch((error) => {
        this.setState({
          loading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      });
    };
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  }

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleClickDelete = (idL3) => {
    this.setState({
      openDialog: true,
      deleteL3Id: idL3,
      confirmationQuestion: 'Tem a certeza que pretende ELIMINAR L3?',
      confirmationMessage: 'A informação será eliminada e não poderá ser recuperada.',
      confirmationFunction: this.handleSubmitDelete,
      cancelFunction: this.handleCloseDialog
    });
  };

  handleSubmitDelete = () => {
    const NegotiationCQ_API = new UsedRentalsCQLotsAPI();
    this.setState({ loading: true })
    NegotiationCQ_API.deleteNegotiationCQ(this.state.deleteL3Id).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.setState({
          success: false,
        });
        this.handleCloseDialog();
        this.reloadTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  deleteButtonRenderer = (idL3) => {
    const { classes } = this.props;
    return (
      <Tooltip title='Eliminar' placement='bottom' >
        <IconButton aria-label='Delete' onClick={() => { this.handleClickDelete(idL3) }} className={classes.buttonSizeTbl} >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    );
  }

  renderTableHeader() {
    const { classes } = this.props;

    return (
      <TableRow className={classes.headerHeight} >
        {headerData.map(column => {
          return (
            <TableCell
              className={classNames(classes.tblHeadT, classes.tblBorderHead, classes.textCenter)}
              key={column.id}
              padding='none'
            >
              {column.label}
            </TableCell>
          );
        }, this)}
        {this.props.estadoId === NEGOTIATION_PHASE && this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) > -1 ?
          <TableCell id='icon' padding='none' className={classNames(classes.tblBorderHead, classes.textCenter)}>
            <RUCQModal estadoId={this.props.estadoId} L2ID={this.props.L2ID} reloadTable={this.reloadTable.bind(this)} newEditButton={true} L1ID={this.props.L1ID} colorData={this.props.colorData} />
          </TableCell>
          :
          null
        }
      </TableRow>
    );
  }

  renderTableRecords(aNegotiationCQLot) {
    const { classes } = this.props;
    const aNegotiationCQ = aNegotiationCQLot.map(negotiationCQLotItem => {
      return (
        <TableRow key={negotiationCQLotItem.RuL3Id} tabIndex={-1} className={classes.tblRow}>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {negotiationCQLotItem.Color}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.qttyWidth)} component='th' scope='row' padding='none'>
            {negotiationCQLotItem.Quantity}
          </TableCell>
          {this.props.estadoId === NEGOTIATION_PHASE && this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) > -1 ?
            <TableCell className={classNames(classes.tblBorder, classes.iconsWidth)} padding='none'>
              <div className={classes.alignIcons}>
                <RUCQModal estadoId={this.props.estadoId} L3data={negotiationCQLotItem} L2ID={this.props.L2ID} L1ID={this.props.L1ID} reloadTable={this.reloadTable.bind(this)} newEditButton={false} colorData={this.props.colorData} />
                {this.deleteButtonRenderer(negotiationCQLotItem.RuL3Id)}
              </div>
            </TableCell>
            :
            null
          }
        </TableRow>
      );
    })
    return aNegotiationCQ;
  }


  render() {
    const { classes } = this.props;
    const { loading } = this.state;

    return (
      <Paper className={classes.tableWrapper}>

        <Table>
          <TableHead className={classes.tblHead}>
            {this.renderTableHeader()}
          </TableHead>
          <TableBody>
            {this.renderTableRecords(this.state.data)}
          </TableBody>
        </Table>
        {loading && <LinearProgress />}

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleCloseDialog.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    );
  }
}

RUCQTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(RUCQTable));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsCreation/UsedRentalsColorQuantity/RUCQTable.js